// @flow
import * as React from 'react';
import { Switch, Redirect, Route, useRouteMatch } from 'react-router-dom';
import CourseA from './course-a'
import CourseB from './course-b/CourseB'

export default function DrivingZone(): React.Element<any> {
  const { path, url } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <Redirect to={`${url}/course-a`} />
      </Route>
      <Route path={`${url}/course-a`} render={(props) => <CourseA {...props} />} />
      <Route path={`${url}/course-b`} render={(props) => <CourseB {...props} />} />
      <Redirect to={path} />
    </Switch>
  );
}